module.exports = __webpack_public_path__ + "static/img/search.25c26aba.png";